import { hbs } from 'ember-cli-htmlbars';
import { workflowComponent } from '@banking/ui/services/bank-accounts';
import { Screen, toggleConfirmBankAccountModalAction } from '@banking/ui/workflows/bank-accounts/confirm-bank-account';
const template = hbs`
  <Banking::BankAccounts::Modal
    @active={{this.showConfirmBankAccountModal}}
    @closeModal={{this.onUserClickCloseModal}}
  >
    {{#if this.showSuccessScreen}}
      <Banking::BankAccounts::SuccessfulBankLink
        @bankLabel={{this.bankLabel.bankAccountLabel}}
        @locationName={{this.locationName}}
        @onDoneClick={{this.onUserClickCloseModal}}
      />
    {{else if this.showErrorScreen}}
      <Banking::BankAccounts::FailedBankLink
        @locationName={{this.selectedLocationName}}
        @onDoneClick={{this.onUserClickCloseModal}}
      />
    {{/if}}
  </Banking::BankAccounts::Modal>
`;
const mapStateToProps = state => ({
  bankLabel: state.confirmBankAccountModal.bankLabel,
  locationName: state.confirmBankAccountModal.locationName,
  showConfirmBankAccountModal: state.confirmBankAccountModal.isModalOpen,
  showErrorScreen: state.confirmBankAccountModal.screen === Screen.ERROR,
  showSuccessScreen: state.confirmBankAccountModal.screen === Screen.SUCCESS
});
const mapActionsToProps = () => ({
  onUserClickCloseModal: toggleConfirmBankAccountModalAction
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);